import { MouseEvent, useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import { IMacKeyword } from "@models/MacDetails";
import { routeNames } from "@core/routeNames";

interface MacChartKeywordProps {
    keyword: IMacKeyword;
    testIdSuffix: string;
    isSelected: boolean;
    hasMenu: boolean;
    hasFoodProfile: boolean;
    onViewMenuExamples: (keyword: IMacKeyword) => void;
}

function MacChartKeyword({ keyword, testIdSuffix, isSelected, hasMenu, hasFoodProfile, onViewMenuExamples }: MacChartKeywordProps) {
    // The menu opens on hover/focus, so after a choice it stays dismissed until the pointer leaves the keyword.
    const [isDismissed, setIsDismissed] = useState(false);

    const viewMenuExamples = (event: MouseEvent<HTMLButtonElement>) => {
        event.currentTarget.blur();
        setIsDismissed(true);
        onViewMenuExamples(keyword);
    };

    return (
        <div
            className={cn('MacChart__keyword', {
                'is-selected': isSelected,
                'has-menu': hasMenu,
                'is-dismissed': isDismissed,
            })}
            onMouseLeave={() => setIsDismissed(false)}
            data-testid={`blockMacDetailsChartWord-${testIdSuffix}`}
        >
            <span
                className="MacChart__keyword-text"
                tabIndex={hasMenu ? 0 : undefined}
            >
                {keyword.text}
            </span>
            {hasMenu && (
                <ul className="MacChart__keyword-menu">
                    {hasFoodProfile && (
                        <li>
                            <Link
                                to={{ pathname: routeNames.food, search: `?q=${encodeURIComponent(keyword.text)}` }}
                                className="MacChart__keyword-menu-item"
                                data-testid={`buttonMacDetailsChartWordViewInSnap-${testIdSuffix}`}
                            >
                                View Food Profile
                            </Link>
                        </li>
                    )}
                    <li>
                        <button
                            type="button"
                            className="MacChart__keyword-menu-item"
                            onClick={viewMenuExamples}
                            data-testid={`buttonMacDetailsChartWordMenuExamples-${testIdSuffix}`}
                        >
                            View Menu Examples
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}

export default MacChartKeyword;
